/****************************************************
 *
 * PostSummarizer v1.00
 *
 * @copyright Zooma 2017
 *
 */


const $body         = $('body')
const $win          = $(window)

const PostSummarizer = class {
    
    constructor($container, options) {
        
        if ($container.length) {
            
            //--------------------------------------------------
            //  Initialize Options
            //--------------------------------------------------
            this.opts = Object.assign({
                enableStartLink     : true,
                collapseOnAction    : true,
                enableResponsive    : false,
                disableHistory      : false,
                targetBodySelector  : '.PostBody',
                targetSelectors     : '.PostBody .hs_cos_wrapper_type_rich_text > h2',   // Supports multiple selectors separated by comma
                topElSelector       : '.header-container-wrapper',
                startLabel          : 'Start',          // Leave empty to hide
                anchorPrefix        : 'section',        // Anchor name, ex: '#section{index}'
                bodyExpandClass     : 'post-summarizer-expanded',
                anchorClassName     : 'SectionAnchor',  // Set on the anchor (#). Be sure to style it
                highlightClass      : 'is-highlighted', // Set on target (heading) when scrolled to
                navTargetClass      : 'target',         // Set on nav link while scrolling
                navActiveClass      : 'active',         // Set on nav link when active (scrollspyed)
                fixedTopNavSel      : '.TopNav',        // Set this if there is a fixed top navigation
                callback            : function(){},
                emptyCallback       : function(){},
                openCallback        : function(){},
                scrollOffset        : 32,
                highlightDuration   : 1500
            }, options)
            
            this.$container         = $container
            this.$targetBody        = $(this.opts.targetBodySelector)
            this.$topNav            = this.opts.fixedTopNavSel !== '' && $(this.opts.fixedTopNavSel) ? $(this.opts.fixedTopNavSel) : false
            this.$footer            = false // Will be set later
            this.scrollSpyData      = []
            this.highlightTimer     = 0
            
            const self          = this
            const $win          = $(window)
            const $targets      = $(this.opts.targetSelectors)
            const readyClass    = 'initiated'
            
            //--------------------------------------------------
            //  Initialize Private Methods
            //--------------------------------------------------
            
            const highlightTarget = el => {
                let targetSelectors = self.opts.targetSelectors.split(',')
                for (let i = 0; i < targetSelectors.length; i++) {
                    let targetSel = targetSelectors[i],
                        $target   = $(targetSel + '.' + self.opts.highlightClass)
                    
                    $target.removeClass(self.opts.highlightClass)
                    el.addClass(self.opts.highlightClass)
                    clearTimeout(this.highlightTimer)
                    
                    this.highlightTimer = setTimeout(() => {
                        el.removeClass(self.opts.highlightClass)
                    }, self.opts.highlightDuration)
                }
            }
            
            const scrollToEl = el => {
                const topNavHeight = this.$topNav.length ? this.$topNav.height() : 0
                const padding = topNavHeight - self.opts.scrollOffset
                zmHelper.scrollTo(el, -(topNavHeight + padding), () => {
                    highlightTarget(el)
                    $container.find('.' + self.opts.navTargetClass).removeClass(self.opts.navTargetClass)
                })
            }
            
            const scrollToTop = () => {
                const topNavHeight = this.$topNav.length ? this.$topNav.height() : 0
                const padding = topNavHeight - self.opts.scrollOffset
                zmHelper.scrollTo(self.opts.topElSelector, -(topNavHeight + padding), () => {
                    $container.find('.' + self.opts.navTargetClass).removeClass(self.opts.navTargetClass)
                })
            }
            
            const clickEvent = el => {
                let selector = el.attr('href'),
                    $tgtEl   = (selector !== "#") ? $(selector) : false
                
                // Attach target class
                if ($tgtEl.length && $tgtEl !== false || $win.scrollTop() > 0) {
                    $container.find('li.' + self.opts.navTargetClass).removeClass(self.opts.navTargetClass)
                    el.parent().addClass(self.opts.navTargetClass)
                }
                
                if ($tgtEl.length && $tgtEl !== false) {
                    
                    scrollToEl($tgtEl)
                    
                    // TODO: Do we need a plugin for cross browser support?
                    if (!this.opts.disableHistory && history.pushState) {
                        history.pushState(null, null, selector);
                        location.hash = selector;
                    }
    
                    if (self.opts.collapseOnAction) {
                        $.event.trigger('PostSummarizer:collapse')
                    }
                    
                }else if ($win.scrollTop() > 0) {
                    scrollToTop()
                    
                    if (!this.opts.disableHistory) {
                        history.pushState(null, null, zmHelper.getCurrentUrlStripQuery())
                    }
    
                    $.event.trigger('PostSummarizer:collapse')
                    
                }else if ($win.scrollTop() === 0) {
    
                    // At the top, clicked on start-link => Scroll to content body start
                    const offset = this.$topNav.length ? this.$topNav.height() : 0
                    zmHelper.scrollTo(this.opts.targetBodySelector, -offset)
                }
            }
            
            const bindEvents = () => {
                // Navigation links
                $container.find('li a').each(function () {
                    $(this).on('click', function (e) {
                        clickEvent($(this))
                        e.preventDefault()
                    })
                })
                // Bind events on section anchors
                $targets.find(`.${this.opts.anchorClassName}`).each(function () {
                    $(this).on('click', function (e) {
                        clickEvent($(this))
                        e.preventDefault()
                    })
                })
            }
            
            //--------------------------------------------------
            //  Initiate Summarizer
            //--------------------------------------------------
            //
            // Generate Content Anchor Links + Sticky Footer
            //
            let listHtml    = `<a class="PostSummarizer-close"><svg class="Icon Icon--cancel"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-cancel"></use></svg></a>
                               <div class="PostSummarizer-inner"><ul>`,
                itemCount   = 0
            
            if ($targets.length) {
                if ($targets.length > 0) {
                    if (this.opts.enableStartLink) {
                        listHtml += `<li class="active start-link"><a href="#">${this.opts.startLabel}</a></li>`
                    }
                    $targets.each(function(index) {
                        let heading  = $(this).text(),
                            anchorId    = zmHelper.slugify(heading) //anchorId    = _opts.anchorPrefix + (index + 1),
                        
                        if (heading.trim().length !== 0) {
                            $(this)
                                .attr('id', anchorId)
                                .prepend(`<a class="${self.opts.anchorClassName}" href="#${anchorId}">#</a>`)
                            
                            listHtml += !self.opts.enableStartLink ? `<li class="active"><a href="#${anchorId}">${heading}</a></li>` : `<li><a href="#${anchorId}">${heading}</a></li>`
                            itemCount++
                        }
                    })
                    listHtml += '</ul></div>'
                    
                    $container
                        .addClass(readyClass)
                        .addClass('PostSummarizer')
                        .html(listHtml)
                }
                
                if ($targets.length && itemCount > 0) {
                    zmConsole.log(`PostSummarizer: Found ${itemCount} items to summarize`)
                    bindEvents()
                    
                    // Initiate ScrollSpy
                    $body.imagesLoaded(() => {
                        setTimeout(() => {
                            this.calcScrollSpy()
                            
                            // Initiate URL Hash on load
                            if (window.location.hash !== "") {
                                const $target = $(window.location.hash)
                                if ($target.length) {
                                    scrollToEl($target)
                                }
                            }
                        }, Config.goldenWaitTime)
                    })
                    
                    self.opts.callback.call()
                    zmConsole.log('PostSummarizer: Initiated')
                }
    
                // Init Sticky Footer
                this.initFooter()
            }
            
            if ($targets.length === 0 || itemCount === 0) {
                zmConsole.log(`PostSummarizer: No targets were found`)
                self.opts.emptyCallback.call()
            }
            
        }else {
            zmConsole.log('PostSummarizer: $el is undefined')
        }
    }
    
    footerOutsideClickListener(event) {
        if (!$(event.target).closest('.PostSummarizerFooter').length && !$(event.target).closest('.PostSummarizer').length && $body.hasClass(self.opts.bodyExpandClass)) {
            closeNav(outsideClickListener)
        }
    }
    
    /**
     *  Append Sticky Footer (if enabled)
     */
    initFooter() {
    
        const self = this
        
        if (this.opts.enableResponsive) {
            $body.append(`<div class="PostSummarizerFooter">
                                    <svg class="Icon Icon--menu">
                                        <use xlink:href="#icon-hamburger"></use>
                                    </svg>
                                    <div class="PostSummarizerFooter-title"><h3></h3></div>
                                </div>`)
            this.$footer = $('.PostSummarizerFooter')
        
            // Set current active headline
            if (this.$footer.length && this.$container.find('.active a').length){
                this.$footer.find('h3').text(this.$container.find('.active a').text())
            }
    
            // Close nav listener
            const closeNav = () => {
                $body
                    .removeClass(self.opts.bodyExpandClass)
                    .off('click')
            }
    
            $('.PostSummary').on('click', function(e) {
                e.stopPropagation()
            })

            this.$footer.on('click', function(e) {
                //e.stopPropagation()
                
                if ($body.hasClass(self.opts.bodyExpandClass)) {
                    closeNav()
                } else {
                    $body
                        .on('click', function(e) {
                            if (!$(e.target).offsetParent().hasClass('PostSummarizerFooter')) {
                                closeNav()
                                e.stopPropagation()
                                e.preventDefault()
                            }
                        })
                        .addClass(self.opts.bodyExpandClass)
                }
    
                self.opts.openCallback.call()
            })
        
            const $navClose = $('.PostSummarizer-close')
            $navClose.on('click', function(e) {
                e.preventDefault()
                closeNav()
            })
            
            // Add listener so that we can collapse the navigation outside of method
            $(document).on('PostSummarizer:collapse', function() {
                closeNav()
            })
        }
    }
    
    /**
     * Recalculate ScrollSpy positions
     */
    calcScrollSpy() {
        
        if (this.$container.length && this.$container.find('a').length) {
            
            const self          = this
            this.$targetBody    = $(this.opts.targetBodySelector)
            this.scrollSpyData  = []
            
            this.$container.find('a').each(function(index) {
                let tgtSelector = $(this).attr('href'),
                    $tgtEl      = $(tgtSelector),
                    tgtPos      = $tgtEl.length ? $tgtEl.offset().top : 0
                
                if (tgtSelector === "#") {
                    
                    // Start item
                    self.scrollSpyData[index] = {
                        linkEl: $(this),
                        position: 0,
                        nextPos: 0
                    }
                    
                }else if ($tgtEl.length && tgtPos > 0) {
                    
                    self.scrollSpyData[index] = {
                        linkEl      : $(this),
                        position    : tgtPos,
                        nextPos     : 0
                    }
                    
                    // Set next position on previous item to indicate where the section stops
                    if (index > 0) {
                        self.scrollSpyData[index - 1].nextPos = tgtPos - 1
                    }
                }
            })
            
            //zmConsole.log(this.scrollSpyData)
            this.updateScrollSpy()
        }
    }
    
    /**
     * Uppate (on scroll)
     */
    updateScrollSpy() {
        const responsive = $win.width() < Config.breakpoints.tablet
        
        if (this.scrollSpyData.length && ((!this.opts.enableResponsive && !responsive) || (this.opts.enableResponsive))) {
            let lookAhead   = !responsive ? $win.height()/5 + this.$topNav.height() : $win.height()/5 + this.$topNav.height(),
                scrollPos   = $win.scrollTop() + lookAhead,
                lastItem    = this.scrollSpyData[ this.scrollSpyData.length - 1]
    
            if (scrollPos > this.$targetBody.offset().top + this.$targetBody.height()) {
                //
                // Scrolled past last item, set title to start-link text and reset active state
                //
                if (this.$footer.length) {
                    this.$container.find('li.' + this.opts.navActiveClass).removeClass(this.opts.navActiveClass)
                    this.$footer.find('h3').text(this.$container.find('.start-link a').text())
                    this.$footer.addClass('scrolled-past')
                }
            }else {
                //
                // Within target body, check heading positions
                //
                this.$footer.removeClass('scrolled-past')
                
                for (let i = 0; i < this.scrollSpyData.length; i++) {
                    const scrollData = this.scrollSpyData[i]
                    if (scrollData !== undefined) {
                        let startPos = scrollData.position,
                            endPos   = scrollData.nextPos > 0 ? scrollData.nextPos : $body.height(),
                            $navItem = scrollData.linkEl.parent()
            
                        //zmConsole.log(scrollData.linkEl.attr('href'), 'scrollPos:', scrollPos, 'startPos:', startPos, 'endPos', endPos)
            
                        if (scrollPos >= startPos && scrollPos <= endPos && !$navItem.hasClass(this.opts.navActiveClass)) {
                            //zmConsole.log('Found a match on', scrollData.linkEl.text())
                            this.$container.find('li.' + this.opts.navActiveClass).removeClass(this.opts.navActiveClass)
                            $navItem.addClass(this.opts.navActiveClass)
                
                            if (this.$footer.length) {
                                this.$footer.find('h3').text($navItem.find('a').text())
                            }
                
                            break
                        } else if (i === this.scrollSpyData.length - 1 && (scrollPos + (4 / 5 * $win.height())) > endPos) {
                            // Scrolled past last item, set title to start-link text and reset active state
                            if (this.$footer.length) {
                                this.$container.find('li.' + this.opts.navActiveClass).removeClass(this.opts.navActiveClass)
                                this.$footer.find('h3').text(this.$container.find('.start-link a').text())
                                this.$footer.addClass('scrolled-past')
                            }
                        }
                    }
                }
            }
        }
    }
}
